/*
 * Ryan O'Dowd
 * 2024-05-18
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    container: {
      flex: 1,
      width: '100%',
      minHeight: 'calc(100vh - 56px - 35px - 114px)', // @TODO: header and footer heights; check mobile; don't hardcode; no idea what the 114px is
      justifyContent: 'center',
      alignItems: 'flex-start',
      margin: 'auto',
      // @TODO: marginBottom: 64,
    },
    sectionWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    releaseNotesWrapper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 200,
      overflow: 'auto',
    },
    note: {
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      paddingLeft: 16,
      textIndent: -16,
      textAlign: 'left',
      marginTop: 0,
      marginBottom: 4,
    },
    invisibleCell: {
      backgroundColor: colors.primaryLight,
    },
    dialog: {
      minWidth: 500, // @TODO: magic...but ugly if too narrow // @TODO: should this be a Dialog.Content prop instead of in styles?
    },
  };
};

export default getStyles;
